var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { action, makeObservable, observable } from "mobx";
import { BaseDialogState } from "../UIComponents/BaseDialog";
export class RecoveryRevealDialogState {
    constructor() {
        this.loading = false;
        this.secret = "";
        this.showpassword = false;
        this.password = "";
        this.bdialogstate = new BaseDialogState();
        makeObservable(this);
        this.bdialogstate.setOkLabel("Download");
        this.bdialogstate.setCancelLabel("Close");
        this.bdialogstate.setHeaderLabel("Recovery Code");
        this.bdialogstate.onOk = () => {
            if (this.showpassword) {
                // maje a request here first
                this.getRecoveryCode();
            }
            else {
                this.downloadAndCloseDialog();
            }
        };
        this.bdialogstate.onClose = () => this.setLoading(false);
        APPEvent.addSubscriberForShowSecretDialog((sec) => {
            if (!sec.useraction || !this.loading) {
                return;
            }
            this.setSecret(sec.secret);
            this.setLoading(false);
        });
    }
    setShowPassword(show) {
        this.showpassword = show;
        if (show) {
            this.setPassword("");
            this.setLoading(false);
            this.bdialogstate.setOkLabel("Reveal");
        }
    }
    setPassword(pwd) {
        this.password = pwd;
        if (!this.password) {
            this.bdialogstate.setDisableOkButton(true);
        }
        else {
            this.bdialogstate.setDisableOkButton(false);
        }
    }
    setLoading(loading) {
        if (loading) {
            this.bdialogstate.setDisableOkButton(true);
        }
        this.loading = loading;
    }
    setSecret(secret) {
        this.bdialogstate.setDisableOkButton(false);
        if (!secret) {
            APPEvent.publishApperror("Sorry, failed to lod your recovery code. Please contact support");
            this.setShowPassword(true);
            return;
        }
        this.bdialogstate.setOkLabel("Download");
        this.secret = secret;
    }
    getRecoveryCode() {
        this.setShowPassword(false);
        this.setLoading(true);
        Apphandler.sendMessage("getrecoverycode", this.password);
    }
    downloadAndCloseDialog() {
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.secret));
        element.setAttribute('download', "letrwing_recoverycode.txt");
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        this.setLoading(false);
        this.bdialogstate.setOpen(false);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], RecoveryRevealDialogState.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RecoveryRevealDialogState.prototype, "secret", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RecoveryRevealDialogState.prototype, "showpassword", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RecoveryRevealDialogState.prototype, "password", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RecoveryRevealDialogState.prototype, "setShowPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RecoveryRevealDialogState.prototype, "setPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RecoveryRevealDialogState.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RecoveryRevealDialogState.prototype, "setSecret", null);
